import React, { Component } from "react";
import {
  BarChart,
  XAxis,
  YAxis,
  Bar,
  ResponsiveContainer,
  Cell,
  ReferenceLine,
  Label
} from "recharts";
import naturalCompare from "natural-compare";
import _ from "lodash";

import { Grid, Chart, Form, Segment, Scrollable } from "components/UI";
import Color from "helpers/Color";
import BarLabel from "./BarLabel";

function handleItemClick(index, callback, data) {
  if (callback) callback(data[index].id);
}

class DoubleBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: props.dataKey2
    };
  }

  handleSortChange = event => {
    this.setState({ sort: event.target.value });
  };

  render() {
    const {
      data,
      dataKey1,
      dataKey2,
      barHeight = 30,
      legendWidth = 75,
      onItemClick,
      color,
      colorKey,
      title
    } = this.props;

    const { sort } = this.state;

    // We want ascending for names (A to Z), but descending for temperatures (high to low).
    // But the values for dataKey2 become negative, so we only need to reverse the order for
    // dataKey1.
    const order = sort === dataKey1 ? -1 : 1;

    if (data.length === 0) return <div />;

    const chartData = data
      .map(item => {
        return {
          id: item.id,
          name: item.name,
          [dataKey1]: _.parseInt(item[dataKey1]) || 0,
          // Make the values for dataKey2 negative so the bars stack with
          // the ones for dataKey1 in the same bar chart.
          [dataKey2]: -_.parseInt(item[dataKey2]) || 0
        };
      })
      .sort((a, b) => order * naturalCompare(a[sort], b[sort]));

    const cells = chartData.map(item => {
      const itemColor = item[colorKey]
        ? color || Color.fromTemperature(Math.abs(item[colorKey]))
        : Color.gray;
      return <Cell key={item.id} fill={itemColor} />;
    });

    const chartHeight = data.length * barHeight + 20;

    return [
      <Grid.Row key="header">
        <Grid.Col width={2}>
          <h2>{title}</h2>
          <Chart.TemperatureLegend small />
        </Grid.Col>
        <Grid.Col>
          <h3>Sort by:</h3>
          <Form.Select
            items={[
              { value: "name", name: "Name" },
              { value: dataKey1, name: `${_.startCase(dataKey1)} Temperature` },
              { value: dataKey2, name: `${_.startCase(dataKey2)} Temperature` }
            ]}
            selected={this.state.sort}
            onChange={this.handleSortChange}
          />
        </Grid.Col>
      </Grid.Row>,
      <Segment.Child key="body">
        <Scrollable height={320}>
          <ResponsiveContainer width="100%" height={chartHeight}>
            <BarChart
              stackOffset="sign"
              layout="vertical"
              data={chartData}
              margin={{ top: 20 }}
            >
              <XAxis type="number" hide />
              <YAxis
                type="category"
                dataKey="name"
                width={legendWidth}
                tickLine={false}
                axisLine={false}
                onClick={(data, index) =>
                  handleItemClick(index, onItemClick, chartData)
                }
                cursor={onItemClick ? "pointer" : "auto"}
              />
              <Bar
                dataKey={dataKey1}
                label={BarLabel(color)}
                isAnimationActive={false}
                minPointSize={10}
                onClick={(data, index) =>
                  handleItemClick(index, onItemClick, chartData)
                }
                cursor={onItemClick ? "pointer" : "auto"}
                stackId="stack"
              >
                {cells}
              </Bar>
              <Bar
                dataKey={dataKey2}
                label={BarLabel(color)}
                isAnimationActive={false}
                minPointSize={10}
                onClick={(data, index) =>
                  handleItemClick(index, onItemClick, chartData)
                }
                cursor={onItemClick ? "pointer" : "auto"}
                stackId="stack"
              >
                {cells}
              </Bar>
              <ReferenceLine x={0} stroke={Color.white} strokeWidth={4} isFront>
                <Label
                  position="top"
                  offset={8}
                  value="Room / Radiator"
                  fontSize={16}
                />
              </ReferenceLine>
            </BarChart>
          </ResponsiveContainer>
        </Scrollable>
      </Segment.Child>
    ];
  }
}

export default DoubleBar;



// WEBPACK FOOTER //
// ./src/components/UI/Chart/DoubleBar.jsx